/* Tiroir panier Kalanne : quantité − / + / saisie / poubelle, sans recharger la page.
   Pendant la requête : le bouton cliqué devient un cercle qui tourne et la quantité pâlit (comme Tystrap). */
(function () {
  if (window.klCartReady) return;
  window.klCartReady = true;
  var busy = false;

  function drawer() { return document.querySelector('cart-drawer'); }

  function apply(res) {
    var d = drawer();
    if (!d || !res.sections) return;
    var html = res.sections['cart-drawer'];
    if (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.querySelector('.kl-cd__inner');
      var dst = d.querySelector('.kl-cd__inner');
      if (src && dst) dst.innerHTML = src.innerHTML;
      d.classList.toggle('is-empty', res.item_count === 0);
    }
    var bubbleHtml = res.sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubbleHtml && bubble) {
      var b = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }
  }

  function change(item, qty, btn) {
    if (busy) return;
    busy = true;
    item.classList.add('is-busy');
    if (btn) btn.classList.add('is-loading');
    fetch((window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(item.dataset.line), quantity: Math.max(0, qty), sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { console.error(res.description || res.message); return; }
        apply(res);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kl-cart', cartData: res });
        }
      })
      .catch(function (e) { console.error(e); })
      .finally(function () {
        busy = false;
        item.classList.remove('is-busy');
        if (btn) btn.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.kl-cd [data-kl-qty]');
    if (!btn) return;
    e.preventDefault();
    change(btn.closest('.kl-cd__item'), parseInt(btn.dataset.klQty, 10) || 0, btn);
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('.kl-cd .kl-cd__qinput');
    if (!input) return;
    var q = parseInt(input.value, 10);
    if (isNaN(q)) q = 1;
    change(input.closest('.kl-cd__item'), q, null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest && e.target.closest('.kl-cd .kl-cd__qinput')) { e.preventDefault(); e.target.blur(); }
  });
})();
